/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HealthResponse } from '../models/health-response';
import { MachineLearningResponse } from '../models/machine-learning-response';

@Injectable({
  providedIn: 'root',
})
export class OpenthreadService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPredictionApiV1OpenthreadGet
   */
  static readonly GetPredictionApiV1OpenthreadGetPath = '/api/v1/openthread/';

  /**
   * Get Prediction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPredictionApiV1OpenthreadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPredictionApiV1OpenthreadGet$Response(params: {
    data_input: any;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, OpenthreadService.GetPredictionApiV1OpenthreadGetPath, 'get');
    if (params) {
      rb.query('data_input', params.data_input, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Get Prediction.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPredictionApiV1OpenthreadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPredictionApiV1OpenthreadGet(params: {
    data_input: any;
  }): Observable<any> {

    return this.getPredictionApiV1OpenthreadGet$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation predictGetDataApiV1OpenthreadSensorsGet
   */
  static readonly PredictGetDataApiV1OpenthreadSensorsGetPath = '/api/v1/openthread/sensors';

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `predictGetDataApiV1OpenthreadSensorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1OpenthreadSensorsGet$Response(params?: {
    data_input?: any;
  }): Observable<StrictHttpResponse<MachineLearningResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpenthreadService.PredictGetDataApiV1OpenthreadSensorsGetPath, 'get');
    if (params) {
      rb.query('data_input', params.data_input, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MachineLearningResponse>;
      })
    );
  }

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `predictGetDataApiV1OpenthreadSensorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1OpenthreadSensorsGet(params?: {
    data_input?: any;
  }): Observable<MachineLearningResponse> {

    return this.predictGetDataApiV1OpenthreadSensorsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MachineLearningResponse>) => r.body as MachineLearningResponse)
    );
  }

  /**
   * Path part for operation healthGetDataApiV1OpenthreadHealthGet
   */
  static readonly HealthGetDataApiV1OpenthreadHealthGetPath = '/api/v1/openthread/health';

  /**
   * Health:Get-Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthGetDataApiV1OpenthreadHealthGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthGetDataApiV1OpenthreadHealthGet$Response(params?: {
  }): Observable<StrictHttpResponse<HealthResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpenthreadService.HealthGetDataApiV1OpenthreadHealthGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HealthResponse>;
      })
    );
  }

  /**
   * Health:Get-Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `healthGetDataApiV1OpenthreadHealthGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthGetDataApiV1OpenthreadHealthGet(params?: {
  }): Observable<HealthResponse> {

    return this.healthGetDataApiV1OpenthreadHealthGet$Response(params).pipe(
      map((r: StrictHttpResponse<HealthResponse>) => r.body as HealthResponse)
    );
  }

}
